/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

// TODO CLEAN : update the dependencies
angular.module('bulbApp.contentEditorModule', ['jquery', 'bulbApp.configModule', 'bulbApp.filtersModule',
  'bulbApp.translateModule', 'bulbApp.utilsModule'])

  .constant('CONTENT_EDITOR', {

    // The BLOCK_TYPE_PATHS provide a mapping between the blockType value of content blocks, and the path portion of
    // urls for editing the blocks.  Ie. /b/rest/units/{unitId}/videoblock/{blockId} would be used for doing crud
    // operations on VIDEO blocks.
    BLOCK_PATHS: {
      IMAGE: 'imageblock',
      IMAGE_CAROUSEL: 'imagecarouselblock',
      VIDEO: 'videoblock',
      ATTACHED_FILE: 'attachedfileblock',
      EMBED: 'embedblock',
      ATTACHED_FILE_EMBED: 'attachedfileembedblock',
      AUDIO: 'audioblock',
    },

    MEDIA_TYPES: {
      IMAGE: {
        assetDefinitionsKey: 'blockImage',
        // TODO CLEAN : get this from CONFIG after merge up from dev
        acceptFileTypes: /(\.|\/)(jpe?g|bmp|gif|png)$/i,
      },
      VIDEO: {
        assetDefinitionsKey: 'blockVideo',
        // TODO CLEAN : get this from CONFIG after merge up from dev
        acceptFileTypes: /(\.|\/)(3g2|3gp|asf|avi|flv|m4v|mkv|mov|mp4|mpg|vob|wmv|quicktime)$/i,
      },
      AUDIO: {
        assetDefinitionsKey: 'blockAudio',
        // TODO CLEAN : get this from CONFIG after merge up from dev
        acceptFileTypes: /(\.|\/)(mp3|m4a|wav)$/i,
      },
    },

    FULL_BLOCK_WIDTH_PERCENTAGE: 0.80,

    MOBILE_AUDIO_BLOCK_WIDTH_PERCENTAGE: 0.90,
    MOBILE_AUDIO_BLOCK_SET_WIDTH_TIMEOUT: 150,

    CAROUSEL: {
      CAROUSEL_GRAB_IMAGE_TIMEOUT: 200,
      SLICK_RENDER_DOTS_PADDING: 35,
      SLICK_RENDER_FIGCAPTION: 10,
    },

    IMAGE_ASSET: {
      IMAGE_ASSET_IMAGE_TIMEOUT: 200,
    },

    ALLOWED_TAGS: ['p', 'h2', 'h3', 'ol', 'ul', 'li', 'blockquote', 'content-block', 'b', 'strong', 'i', 'em', 'u', 'a',
      'span', 'br'],

    GRAB_TOOLBAR_TIMEOUT: 100,

    // The FONTS provide an easily changable array of the currently acceptable fonts that bulb allows. This value
    // is used in the dropdown extension on the toolbar.
    FONTS: [{ FONT_CODE: 'font_family_code_calluna', FONT: 'calluna, serif' },
      { FONT_CODE: 'font_family_code_baskerville', FONT: 'baskerville-urw, serif' },
      { FONT_CODE: 'font_family_code_courier_prime', FONT: 'courier-prime, serif' },
      { FONT_CODE: 'font_family_code_museo_sans', FONT: 'museo-sans, sans-serif' },
      { FONT_CODE: 'font_family_code_proxima_nova', FONT: 'proxima-nova, sans-serif' }],

    // The COLORS provide an easily changable array of the currently acceptable font colors that bulb allows. This
    // value is used in the color picker extension on the toolbar.
    // [_variables.scss colors], left -> right:
    //         $bulb-dark-gray, $bulb-darker-accent-colors(6), null, $bulb-dark-medium-gray, $bulb-light-gray.
    // TODO FUTURE: Figure out how to have the .SCSS files and .JS files use the same constants rather than having
    // them declared separately!
    COLORS: ['#363d47', '#2b91bf', '#0077a7', '#4f5967', '#acb3bf'],

    // These are the default values for the editor, both the font color and the font families.
    DEFAULT_COLOR: '#363d47',
    DEFAULT_FONT: { FONT_CODE: 'font_family_code_calluna', FONT: 'calluna, serif' },
    MINIMUM_IMAGE_WIDTH: 200,
  })
  .run(['CONTENT_EDITOR', '$translate', function (CONTENT_EDITOR, $translate) {
    for (let i = 0; i < CONTENT_EDITOR.FONTS.length; i++) {
      const currentFont = CONTENT_EDITOR.FONTS[i];
      $translate(currentFont.FONT_CODE).then((translation) => {
        currentFont.FONT_NAME = translation;
      });
    }
  }]);
